import React from 'react';


export let QueryContext = React.createContext({
    search: {search: [], records: []},
    report: {report: null, records: []},
    selected: {records: [], columns: []},
    setMinDate: _ => {},
    setMaxDate: _ => {},
    setRecordLimit: _ => {},
    setReport: _ => {},
    setConfig: _ => {}
})